<div class="unauthorized-container">
  <svg width="300" height="300" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="10" stroke="#FF4C4C" stroke-width="2" fill="none"/>
    <line x1="7" y1="7" x2="17" y2="17" stroke="#FF4C4C" stroke-width="2"/>
    <line x1="7" y1="17" x2="17" y2="7" stroke="#FF4C4C" stroke-width="2"/>
  </svg>
  <h1>403 - Access Denied</h1>
  <p>You do not have permission to view this page.</p>
</div>